import React, { useEffect, useState } from 'react'
import styled from 'styled-components';

export const PaginationButton = ( props: any ) => {


    const [ totalPages, setTotalPages ] = useState( Math.ceil(props.data.length/props.itemPerPage) );
    const [ totalItems, setTotalItems ] = useState( props.data.length ? props.data.length : 1 );

    const [ currentPage, setCurrentPage ] = useState( 1 );

    useEffect( ( ) => { 

        props.actionHandler( currentPage );

    }, [ currentPage ] );

    const nextButton = ( ) => {

        if ( currentPage === totalPages ) {
            setCurrentPage( currentPage );
            // props.actionHandler( currentPage );
        }
        else {
            setCurrentPage( currentPage => currentPage + 1 );
            // props.actionHandler( currentPage );
        }
        console.log( 'next button clicked' );
    }

    const prevButton = ( ) => {

        if ( currentPage === 1 ) {
            setCurrentPage( currentPage );
            // props.actionHandler( currentPage );
        }
        else {
            setCurrentPage( currentPage => currentPage - 1 );
            // props.actionHandler( currentPage );
        }
        console.log( 'next button clicked' );

    }

    return (
    
        <PaginationButtonWrapper>
            <button className = 'pagination-button' onClick = { prevButton } >Prev</button>
            <span>{ currentPage }</span>
            <button className = 'pagination-button' onClick = { nextButton } >Next</button>    
        </PaginationButtonWrapper>
    );
}

const PaginationButtonWrapper = styled.div`

    .pagination-button {

    }

    button {
        background: transparent;
        border: 1px solid black;
        border-radius: 5px;
        padding: 5px 15px;
        margin: 5px;
        font-size: 20px;
    }
    

`; 

